import { apiEndpoints } from '@/apiEndpoints';
import axios from 'axios';

export const getFileUrl = async (
  key: string | null,
  original = false,
  accessToken?: string,
) => {
  if (key === null) return null;
  const result = await axios.get<{ url: string }>(
    apiEndpoints.s3.signUrl(key),
    { params: { original, accessToken } },
  );
  return result.data;
};

export const getCompressedFilesUrls = async (
  keys: string[],
  accessToken?: string,
) => {
  const result = await Promise.all(
    keys.map((key) => getFileUrl(key, false, accessToken)),
  );
  return result.filter((v) => v != null);
};
